import { render, staticRenderFns } from "./DetailSidebarRight.vue?vue&type=template&id=788491f0"
import script from "./DetailSidebarRight.vue?vue&type=script&lang=ts"
export * from "./DetailSidebarRight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports